module.exports = __webpack_public_path__ + "img/puzzle-piece.262a5526.svg";